import React from 'react';
import { RadioButtonGroup } from 'framework/form';
import { SOURCING_FILTERS } from '../constants';
import { ENGLISH_LEVEL_SHORT_OPTIONS } from 'domain/shared/core/constants';
import { mergeSx } from 'framework/utils';
import { SxProps, Theme } from '@mui/material';

const englishLevels = Object.values(ENGLISH_LEVEL_SHORT_OPTIONS).map(item => {
  return {
    value: item,
    label: item,
  };
});

type RadioButtonsSourcingFilterProps = Omit<React.ComponentProps<typeof RadioButtonGroup>, 'options' | 'source'>;

const fieldSx: SxProps<Theme> = {
  '& .MuiFormGroup-root': {
    margin: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gridTemplateRows: 'repeat(4, auto)',
    gridAutoFlow: 'column',
  },
  '& .MuiFormControlLabel-root': {
    marginLeft: 0,
    '& > .MuiRadio-root': { padding: '0' },
    '& .MuiTypography-root': { marginLeft: 0.5 },
  },
};

const EnglishLevelsSourcingFilter = ({ sx, ...props }: RadioButtonsSourcingFilterProps) => {
  return (
    <RadioButtonGroup
      label=""
      source={SOURCING_FILTERS.englishLevel}
      options={englishLevels}
      sx={mergeSx(fieldSx, sx)}
      {...props}
    />
  );
};

export default EnglishLevelsSourcingFilter;
